import { DataSnapshot, onChildAdded } from "firebase/database";
import {
    INotificacao,
    INotificacaoAlerta,
    INotificacaoURA,
} from "../../../Interfaces/Geral/Notificacao/NotificacaoInterfaces";
import {
    getNotificacoesAlertaCRMV2Ref,
    getNotificacoesURACRMV2Ref,
} from "../../../Services/Config/ConfigFirebaseCliente";
import {
    AtualizarNotificacaoComoLidaService,
    AtualizarNotificacaoComoNaoLidaService,
    AtualizarNotificacaoLidaService,
    ListarAtividadesNotificacaoUsuarioPorModuloService,
    ListarAtividadesNotificacaoUsuarioService,
    ListarGrupoNotificacoesService,
    ListarNotificacoesPorUsuarioService,
    ListarNotificacoesTransferenciaService,
    ListarNotificacoesUsuarioService,
    ListarUltimasNotificacoesUsuarioService,
} from "../../../Services/Geral/Notificacao/NotificacaoServices";
import { Controller } from "../../Controller";

export const ListarAtividadesNotificacaoUsuario = () =>
    Controller(ListarAtividadesNotificacaoUsuarioService());

export const ListarAtividadesNotificacaoUsuarioPorModulo = (idModulo: number) =>
    Controller(ListarAtividadesNotificacaoUsuarioPorModuloService(idModulo));

export const AtualizarNotificacaoComoLida = (idNotificacao: number) =>
    Controller(AtualizarNotificacaoLidaService(idNotificacao, true));
export const AtualizarNotificacaoComoNaoLida = (idNotificacao: number) =>
    Controller(AtualizarNotificacaoLidaService(idNotificacao, false));

export const ListarNotificacoesUsuario = (somenteLidas?: boolean) =>
    Controller(ListarNotificacoesUsuarioService(somenteLidas));

export const ListarUltimasNotificacoesUsuario = () =>
    Controller(ListarUltimasNotificacoesUsuarioService());

export const ListarNotificacoesTransferenciaController = () =>
    Controller(ListarNotificacoesTransferenciaService());

export const ListarNotificacoesPorUsuarioController = (PAGINA: number) =>
    Controller(ListarNotificacoesPorUsuarioService(PAGINA));

export const AtualizarNotificacaoLidaController = (
    lstNotificacoes: Array<INotificacao>
) => Controller(AtualizarNotificacaoComoLidaService(lstNotificacoes));

export const AtualizarNotificacaoNaoLidaController = (
    lstNotificacoes: Array<INotificacao>
) => Controller(AtualizarNotificacaoComoNaoLidaService(lstNotificacoes));

export const ListarGrupoNotificacoesController = (
    PAGINA: number,
    flTransferencia: boolean
) => Controller(ListarGrupoNotificacoesService(PAGINA, flTransferencia));

export function ListenNotificacoesAlertaController(
    ID_ORGANIZACAO: string,
    ID_USUARIO: number,
    listener: (notificacao: INotificacaoAlerta, snap: DataSnapshot) => unknown
) {
    const notificacoesAlertasRef = getNotificacoesAlertaCRMV2Ref(
        ID_ORGANIZACAO,
        ID_USUARIO
    );

    return onChildAdded(notificacoesAlertasRef, async (snap) => {
        if (snap.exists()) listener(snap.toJSON() as INotificacaoAlerta, snap);
    });
}

export function ListenNotificacoesURAController(
    ID_ORGANIZACAO: string,
    ID_USUARIO: number,
    listener: (notificacao: INotificacaoURA, snap: DataSnapshot) => unknown
) {
    const notificacoesURARef = getNotificacoesURACRMV2Ref(
        ID_ORGANIZACAO,
        ID_USUARIO
    );
    return onChildAdded(notificacoesURARef, async (snap) => {
        if (snap.exists()) listener(snap.toJSON() as INotificacaoURA, snap);
    });
}
